module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-搜索-亮.327de.png";